import { Component } from "@theme/component";
import { ThemeEvents } from "@theme/events";
import { Wishlist } from "./wishlist-store";

class WishlistToggle extends Component {
  connectedCallback(): void {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.wishlistUpdate, this.#sync);
    this.#sync();
  }

  updatedCallback(): void {
    super.updatedCallback();
    // The Section Rendering API morphs (patches) existing nodes in place rather than
    // reconnecting them, so connectedCallback doesn't run again after a re-render
    // (e.g. facet updates, or the vehicle-selector's replay-on-load). Re-sync here too,
    // mirroring compare-toggle's updatedCallback usage for the same reason.
    this.#sync();
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.wishlistUpdate, this.#sync);
  }

  handleClick(event: Event): void {
    event.preventDefault();
    const handle = this.dataset.productHandle ?? "";
    if (!handle) return;
    if (Wishlist.contains(handle)) {
      Wishlist.removeHandle(handle);
    } else {
      Wishlist.addHandle(handle);
    }
  }

  #sync = (): void => {
    const handle = this.dataset.productHandle ?? "";
    const active = Wishlist.contains(handle);
    this.classList.toggle("in-wishlist", active);
    const button = this.querySelector("button");
    button?.setAttribute("aria-pressed", String(active));
  };
}

if (!customElements.get("wishlist-toggle")) {
  customElements.define("wishlist-toggle", WishlistToggle);
}
